import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=18d5a73d&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=18d5a73d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5a73d",
  null
  
)

export default component.exports